import { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import useAuthUser from "../components/Hooks/useAuthUser";

const AuthProtected = (props) => {
  const { userProfile, token, loading } = useAuthUser();

  // Set auth header when token is available
  useEffect(() => {
    if (token) {
      setAuthorization(token);
    }
  }, [token]);

  // Wait for auth state to be ready
  if (loading) return null;

  // Not logged in → redirect (WITHOUT logout API)
  if (!token || !userProfile) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location },
        }}
      />
    );
  }

  return <>{props.children}</>;
};

// roles: who may open the page; anyone else goes to /403 (HXSMSF-144)
const AccessRoute = ({
  component: Component,
  layout: Layout,
  roles,
  ...rest
}) => {
  const { roles: userRoles } = useAuthUser();
  const allowed =
    !roles || (userRoles || []).some((role) => roles.includes(role));

  return (
    <Route
      {...rest}
      render={(props) =>
        allowed ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/403" />
        )
      }
    />
  );
};

export { AuthProtected, AccessRoute };
